var ProfileService = /** @class */ (function () {
    function ProfileService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Starts change email routine. User will get email with link to verify
     * email account
     * @param requestBody
     * @returns ChangeEmailResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    ProfileService.prototype.profileChangeEmail = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/change-email',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Allows user to change his password
     * @param requestBody
     * @returns ChangePasswordResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    ProfileService.prototype.profileChangePassword = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/change-password',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Allows user to change their phone
     * @param requestBody
     * @returns ChangePhoneResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    ProfileService.prototype.profileChangePhone = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/change-phone',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * @param requestBody
     * @returns LoginResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    ProfileService.prototype.profileConsent = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/consent',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Starts password recovery routine. As a results user will get email with instructions how
     * to recover access to the account
     * @param requestBody
     * @returns any OK
     * @returns Status Default error response
     * @throws ApiError
     */
    ProfileService.prototype.profileForgotPassword = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/forgot-password',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    /**
     * Allows user to set new password with transient token received via email
     * @param requestBody
     * @returns ResetPasswordResponse OK
     * @returns Status Default error response
     * @throws ApiError
     */
    ProfileService.prototype.profileResetPassword = function (requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/reset-password',
            body: requestBody,
            mediaType: 'application/json'
        });
    };
    return ProfileService;
}());
export { ProfileService };
//# sourceMappingURL=ProfileService.js.map